import { ComponentChildren } from 'preact';
import { BUTTON_VARIANTS } from './Button.constant';
import { Container, ButtonLink } from './Button.styles';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ComponentChildren;
  variant?: keyof typeof BUTTON_VARIANTS;
  block?: boolean;
  disabled?: boolean;
}

const Button = ({
  variant = BUTTON_VARIANTS.fulfilled,
  block = false,
  children,
  disabled = false,
  ...rest
}: ButtonProps): JSX.Element => {
  if (variant === BUTTON_VARIANTS.link) {
    return <ButtonLink {...rest}>{children}</ButtonLink>;
  }

  return (
    <Container variant={variant} block={block} disabled={disabled} {...rest}>
      {children}
    </Container>
  );
};

export default Button;
